'use client';

import { StickyEnrollBarProps } from '@/widgets/landing-page-widgets/StickyEnrollBar/schema';
import { cn } from '@admin/lib/utils';
import { Button, Typography } from '@pw-tech/omni-ui';
import styles from './styles.module.css';

const StickyEnrollBar = ({
  handleOpenBookDemoModal,
  isStickyVisible,
  hasBeenVisible,
  bottomStickyBarData,
}: {
  handleOpenBookDemoModal: ({ clickFrom }: { clickFrom: string }) => void;
  isStickyVisible: boolean;
  hasBeenVisible: boolean;
  bottomStickyBarData: StickyEnrollBarProps;
}) => {
  return (
    <div
      className={cn(
        'fixed z-[999] md:bottom-8 bottom-0 inset-x-0',
        !hasBeenVisible && !isStickyVisible
          ? 'translate-y-[200%] opacity-0'
          : isStickyVisible
            ? styles.animateUp
            : styles.animateDown
      )}
    >
      <div
        className="py-4 px-[40px] bg-white md:max-w-[960px] w-full md:rounded-2xl rounded-b-none mx-auto flex flex-row justify-between gap-2 items-center"
        style={{ backdropFilter: 'blur(10px)', boxShadow: '0px -4px 16px 0px #0000001a' }}
      >
        <div>
          <Typography variant="heading4" weight="bold" color="#1b2124">
            {bottomStickyBarData?.bottomStickyBar?.heading}
          </Typography>
          <Typography variant="small" className="hidden md:block mt-2" color="#414347">
            {bottomStickyBarData?.bottomStickyBar?.subHeading}
          </Typography>
        </div>
        <Button
          className="md:min-w-[200px] bg-gradient-to-b from-[#ff9d5b] to-[#ff6d0a]"
          onClick={() => handleOpenBookDemoModal({ clickFrom: 'sticky' })}
        >
          {bottomStickyBarData?.bottomStickyBar?.buttonText}
        </Button>
      </div>
    </div>
  );
};

export default StickyEnrollBar;
